import "./navbar.css";
import React, { useState } from "react";
import { Link } from "@reach/router";
import { Icon, Menu } from "antd";

export const Navbar = () => {
  const [page, setPage] = useState(() => window.location.pathname);
  if (page === "/") {
    return null;
  }
  return (
    <div className="navbar">
      <Menu
        size="small"
        mode="horizontal"
        onClick={e => setPage(e.key)}
        selectedKeys={[page]}
        style={{ display: "flex", justifyContent: "center" }}
      >
        <Menu.Item key="/">
          <Link to="/">
            <Icon type="home"></Icon>
            Home
          </Link>
        </Menu.Item>
        <Menu.Item key="/camera">
          <Link to="/camera">
            <Icon type="camera"></Icon>
            Camera
          </Link>
        </Menu.Item>
        <Menu.Item key="/quiz" size="small">
          <Link to="/quiz">
            <Icon type="form"></Icon>
            Teste
          </Link>
        </Menu.Item>
        <Menu.Item key="/sobre" size="small">
          <Link to="/sobre">
            <Icon type="info-circle"></Icon>
            Sobre
          </Link>
        </Menu.Item>
      </Menu>
    </div>
  );
};
